import React, { Component } from "react";
import ParticlesBg from "particles-bg";
import Fade from "react-reveal";
import SwitchLang from "./SwitchLang";
// import { noConflict } from "jquery";

class Header extends Component {
  render() {
    if (!this.props.data) return null;

    const description = this.props.data.description;
    const description2 = this.props.data.description2;

    return (
      <header id="home">
        <ParticlesBg type="circle" bg={true} />

        <nav id="nav-wrap">
          <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
            Show navigation
          </a>
          <a className="mobile-btn" href="#home" title="Hide navigation">
            Hide navigation
          </a>{" "}
          <ul id="nav" className="nav">
            {/* START switch language */}
            <span className="current">
              <a href="/">
                <SwitchLang />
              </a>
            </span>
            {/* END switch language */}
            <li className="current">
              <a className="smoothscroll" href="#home">
                Home
              </a>
            </li>

            <li>
              <a className="smoothscroll" href="#about">
                About
              </a>
            </li>

            <li>
              <a className="smoothscroll" href="#resume">
                Resume
              </a>
            </li>

            <li>
              <a className="smoothscroll" href="#contact">
                Contact
              </a>
            </li>

            <li>
              <a href="/works">
                <u>Works</u>
              </a>
            </li>
          </ul>
        </nav>

        <div className="row banner">
          <div className="banner-text">
            <Fade bottom>
              <h1 className="responsive-headline">Taha Yazdani</h1>
            </Fade>
            <Fade bottom duration={1200}>
              <h3>{description}</h3>
              <h3>
                {description2} <i class="fa fa-heart" aria-hidden="true"></i>
              </h3>
            </Fade>
            <Fade bottom duration={2000}>
              <ul className="social">
                <br />

                {/* company buttoms */}
                {/* <a
                  rel="noreferrer"
                  href={""}
                  className="button btn github-btn"
                  target="_blank"
                >
                  <i class="fa fa-sitemap"></i>QeshmSite ©
                </a> */}
              </ul>
            </Fade>
          </div>
        </div>

        <p className="scrolldown">
          <a
            className="smoothscroll"
            href="#about"
            style={{ fontSize: "40px", paddingTop: "10px" }}
          >
            <i className="icon-down-circle"></i>
          </a>
        </p>
      </header>
    );
  }
}

export default Header;
